// test2523
(2523 && 0);
